import type { PricingSegment } from '@/types/marketplace'

export interface RecommendedProduct {
  /** A name slug (marketplaceCatalogProducts), not the Rails product_key */
  slug: string
  /** Pins the card to this segment's title, price, and link */
  segment?: PricingSegment
}

// GCC High entries lead each group (.claude/rules/marketplace-branding.md)
export const RECOMMENDED_PRODUCTS: Record<'smb' | 'enterprise' | 'standalone', RecommendedProduct[]> = {
  smb: [
    { slug: 'm365-business-premium-gcch', segment: 'gcc-high' },
    { slug: 'microsoft-365-business-basic' },
    { slug: 'microsoft-365-business-standard' },
    { slug: 'microsoft-365-business-premium' },
  ],
  enterprise: [
    { slug: 'm365-g3-unified-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'm365-g5-fusl-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'm365-f3-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'o365-g3-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'o365-g1-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'microsoft-365-e5' },
    { slug: 'office-365-e1' },
    { slug: 'microsoft-365-e3' },
  ],
  standalone: [
    { slug: 'entra-id-p2-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'visio-p2-gcch-sub-per-user', segment: 'gcc-high' },
    { slug: 'microsoft-entra-id-p2-for-government', segment: 'gcc' },
    { slug: 'planner-and-project-plan-3' },
    { slug: 'microsoft-entra-id-p1' },
    { slug: 'microsoft-defender-for-endpoint-p2' },
    { slug: 'microsoft-intune-plan-1' },
    { slug: 'visio-plan-2' },
    { slug: 'exchange-online-plan-1' },
  ],
}

// Google rows have no SKU code, so the core plans are picked by their TD SYNNEX names
export const GOOGLE_WORKSPACE_RECOMMENDED = [
  'Google Workspace Business Starter',
  'Google Workspace Business Standard',
  'Google Workspace Business Plus',
  'Google Workspace Enterprise Standard',
]

/** Curated order for the popularity sort */
export const FLAGSHIP_PRODUCTS: RecommendedProduct[] = [
  { slug: 'm365-g3-unified-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'm365-g5-fusl-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'm365-f3-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'o365-g3-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'o365-g1-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'microsoft-365-e3' },
  { slug: 'microsoft-365-e5' },
  { slug: 'microsoft-365-e7' },
  { slug: 'microsoft-365-business-premium' },
  { slug: 'm365-business-premium-gcch', segment: 'gcc-high' },
  { slug: 'microsoft-365-business-standard' },
  { slug: 'microsoft-365-business-basic' },
  { slug: 'microsoft-365-f3' },
  { slug: 'microsoft-365-f1' },
  { slug: 'office-365-e1' },
  { slug: 'office-365-e3' },
  { slug: 'office-365-e5' },
  { slug: 'microsoft-defender-for-endpoint-p2' },
  { slug: 'entra-id-p2-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'microsoft-entra-id-p2' },
  { slug: 'power-bi-pro' },
  { slug: 'microsoft-intune-plan-1' },
  { slug: 'visio-p2-gcch-sub-per-user', segment: 'gcc-high' },
  { slug: 'exchange-online-plan-1' },
  { slug: 'exchange-online-plan-2' },
  { slug: 'microsoft-teams-phone-standard' },
]
